export enum TipoAprovacao {
  CALCULO_BONIFICACAO = 'CALCULO_BONIFICACAO',
  CAMPANHA_BONIFICACAO = 'CAMPANHA_BONIFICACAO',
  VERBA_EXTRA = 'VERBA_EXTRA',
}
